import React, { CSSProperties } from "react";

export default function IconSettings(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M12 2a1 1 0 0 1 1 1v1a8 8 0 0 1 2.1.6l.5-.9a1 1 0 1 1 1.8 1l-.6 1a8 8 0 0 1 1.6 1.5l.9-.6a1 1 0 1 1 1 1.8l-1 .5c.4.7.5 1.4.6 2.1H21a1 1 0 0 1 0 2h-1a8 8 0 0 1-.6 2.1l.9.5a1 1 0 1 1-1 1.8l-1-.6a8 8 0 0 1-1.5 1.6l.6.9a1 1 0 1 1-1.8 1l-.5-1a8 8 0 0 1-2.1.6V21a1 1 0 0 1-2 0v-1a8 8 0 0 1-2.1-.6l-.5.9a1 1 0 1 1-1.8-1l.6-1a8 8 0 0 1-1.6-1.5l-.9.6a1 1 0 1 1-1-1.8l1-.5A8 8 0 0 1 4 13H3a1 1 0 0 1 0-2h1l.6-2.1-.9-.5a1 1 0 0 1 1-1.8l1 .6a8 8 0 0 1 1.5-1.6l-.6-.9a1 1 0 0 1 1.8-1l.5 1A8 8 0 0 1 11 4V3a1 1 0 0 1 1-1Zm0 11.2-4.6 2.6c.4.6 1 1 1.6 1.4a6 6 0 0 0 5.7.2l.3-.2a6 6 0 0 0 1.6-1.4L12 13.2ZM11 6a6 6 0 0 0-1.7.5l-.3.2a6 6 0 0 0-2 1.9l-.2.3a6 6 0 0 0-.5 4.8v.3l4.7-2.7V6.1Zm2 0v5.3l4.6 2.7a6 6 0 0 0-.2-4.8l-.2-.3a6 6 0 0 0-1.9-2l-.3-.2a6 6 0 0 0-1.7-.7H13Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
